export const cartSummary = [
  { label: "Shipping:", value: "Calculated at checkout" },
  { label: "Tax:", value: "Calculated at checkout" },
];
